function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledVerticalTabs } from "./vertical-tabs.scss";
import DefaultProps from "./default-props";
import VerticalTabsDesktopComponent from "./vertical-tabs-desktop/vertical-tabs-desktop-component";
import VerticalTabsMobileComponent from "./vertical-tabs-mobile/vertical-tabs-mobile-component";
class VerticalTabs extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(StyledVerticalTabs, {
            className: "vertical-tabs",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "desktop-wrapper",
                    children: /*#__PURE__*/ _jsx(VerticalTabsDesktopComponent, _object_spread({}, this.props))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-wrapper",
                    children: /*#__PURE__*/ _jsx(VerticalTabsMobileComponent, _object_spread({}, this.props))
                })
            ]
        });
    }
}
export { VerticalTabs as default };
VerticalTabs.defaultProps = DefaultProps;
